import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../hooks/useLanguage';

const ReactMarkdown = require("react-markdown");


const DefaultInfo = ({ aboutSchoolData }) => {
  const langToggle = useLanguage;
  return (
    <section className="default-info" data-scroll-section>
      <div className="content-wrapper">
        <div className="default-info__header">
          <span className="default-info__header-marker">
            {langToggle(aboutSchoolData.marker_ua, aboutSchoolData.marker_ru)}
          </span>
          <h2 className="default-info__header-title">
            {langToggle(aboutSchoolData.title_ua, aboutSchoolData.title_ru)}
          </h2>
        </div>
        <div className="default-info__description">
          <ReactMarkdown source={langToggle(aboutSchoolData.description_ua, aboutSchoolData.description_ru)} />  
        </div>
      </div>
    </section>
  );
};

DefaultInfo.propTypes = {
  aboutSchoolData: PropTypes.object,
};

export default DefaultInfo;
